import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { arrType, converAttrToDatagridCol, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { totalSizeRatioColumn } from "../../data";
import { convertSizeStringToStandardInputFormat, convertWarehouseStringToStandardInputFormat, orderQtyStaticColumns } from "../data";

import { Box, Typography, Stack } from "@mui/material";
import DisplayTable from "components/ReusableComponents/DisplayTable";

const ChannelQtyWarehouseSplit = ({
	tableColumns,
	channel,
	whSplitRows,
	channelQtyData,
	handleDataChange,
	allChannels,
	allSizes,
	allWarehouses = [],
	editMode = false,
}) => {
	const tableRowsState = Object.values(
		whSplitRows
			.filter((row) => row.channel === channel)
			.reduce((acc, curr) => {
				acc[curr.warehouse] = curr;
				return acc;
			}, {})
	);
	const tableWhQtyDisplayRows = Object.values(
		whSplitRows
			.filter((row) => row.channel === channel)
			.reduce((acc, row) => {
				if (acc[row.size] === undefined) acc[row.size] = { size: row.size };

				acc[row.size] = {
					...acc[row.size],
					[row.warehouse]: row.qty,
				};
				return acc;
			}, {})
	);

	const handleRowDataChange = (newRow, oldRow) => {
		return handleDataChange(newRow, oldRow, channel);
	};

	return (
		<Stack width="500px" spacing={2}>
			<Typography variant="h6" mr={2}>
				Warehouse Split - {channel}
			</Typography>
			<Box>
				<Typography variant="body1" mr={2}>
					Ratio
				</Typography>
				<DataGrid
					rows={tableRowsState ? tableRowsState : []}
					getRowId={(row) => row.warehouse}
					columns={tableColumns.map((col) => converAttrToDatagridCol(col))}
					sx={{
						width: "70%",
						// maxHeight: 250,
						"& .MuiDataGrid-row": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-row:hover": {
							backgroundColor: "transparent",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[400],
							textTransform: "uppercase",
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
					}}
					density="compact"
					disableRowSelectionOnClick
					pagination={false} // Remove footer
					hideFooter={true}
					showCellVerticalBorder
					showColumnVerticalBorder
					isCellEditable={({ row }) => editMode}
					processRowUpdate={handleRowDataChange}
					autoHeight
				/>
			</Box>

			<Box width={300}>
				<Typography variant="body1" mr={2}>
					Size Qty Split
				</Typography>
				<DisplayTable
					size="small"
					textAlign="center"
					columns={[
						{
							name: "Size",
							key: "size",
							data_type: datatypes.STRING.key,
							input_type: inputTypes.ENTER.key,
							renderHeader: (col) => (
								<Box
									sx={{
										display: "flex",
										justifyContent: "center",
										width: "100%",
										alignItems: "center",
										background: grey[400],
										p: 1,
										boxSizing: "border-box",
									}}>
									<span>{col.name}</span>
								</Box>
							),
						},
						...allWarehouses.map((wh) => convertWarehouseStringToStandardInputFormat(wh)),
					]}
					rows={tableWhQtyDisplayRows}
					// rows={[
					// 	{
					// 		size: "total",
					// 		size_qty: channelQtyData
					// 			?.filter((row) => row.channel === channel)
					// 			.map((row) => +row.size_qty)
					// 			.reduce((acc, curr) => acc + curr, 0),
					// 	},
					// 	...channelQtyData
					// 		?.filter((row) => row.channel === channel)
					// 		.map((row) => {
					// 			let { size, size_qty, ...rest } = row;

					// 			return { size, size_qty };
					// 		}),
					// ]}
				/>
			</Box>
		</Stack>
	);
};

export default ChannelQtyWarehouseSplit;
